/* global $ */

function createAlert(html, insertBeforeLocationQuery) {
	$(html)
		.insertBefore(insertBeforeLocationQuery)
		.alert({
			closeable: true,
			open: false,
			removable: true,
			size: 'slim',
			onOpen($alert) {
				$alert.addClass('signInAlert');
			}
		})
		.alert('open');
}

export default createAlert;



// WEBPACK FOOTER //
// ./app/public/src/js/utils/createAlert.js